import { DocsContainer } from 'containers/DocsContainer'
import { NextPage } from 'next'
import React from 'react'
import { ApiDocument } from 'containers/ApiDocument'

interface ApiPageProps {
  slug: string
}

const ApiPage: NextPage<ApiPageProps> = ({ slug }) => (
  <DocsContainer>
    <ApiDocument id={slug} />
  </DocsContainer>
)

ApiPage.getInitialProps = async (ctx) => {
  const slug = ctx.query.slug as string
  return { slug }
}

export default ApiPage
